import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Select, Row, Col, Spin, Breadcrumb, DatePicker, Typography, Button } from 'antd';
import dayjs from 'dayjs';
import { Country } from 'country-state-city';
import { formItemLayout, unexpectedError, tailFormItemLayout, handleBackendFormErrors, backButton } from '../../common_functions';

const Artist = props => {
  const { section, id } = useParams();
  const [artist, setArtist] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef('');

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        if (section && id) {
          const { data } = await props.getItem('Artist', id, { fields: ['*'] });
          setArtist(data);
          data.dob = !!data.dob ? dayjs(data.dob, 'YYYY-MM-DD') : null;
          data.dod = !!data.dod ? dayjs(data.dod, 'YYYY-MM-DD') : null;
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        console.error(error);
        unexpectedError();
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      values = {
        ...values,
        creator: `${values.First_Name} ${values.last_name}`,
      };

      if (section === 'new' && artist.id) {
        props.history.push('/Artist/edit/' + artist.id);
        return;
      }

      let newState = { ...artist, ...values };
      const response = await props.saveItem('Artist', newState);

      if (response) {
        notification['success']({
          message: !!id ? 'Artist updated successfully!' : 'Artist saved successfully!',
          duration: 2,
        });
        backButton(props, `/artists`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb items={[{ title: "Artists", href: "/artists" }, { title: id ? `Edit Artist: ${id}` : 'Add New Artist' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id ? `Edit Artist: ${id}` : 'Add New Artist'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    name="First_Name"
                    label="First Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'First name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter first name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    name="last_name"
                    label="Last Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Last name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter last name" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    name="dob"
                    label="DOB"
                    rules={[
                      {
                        required: true,
                        message: 'DOB is required!',
                      },
                    ]}
                  >
                    <DatePicker picker="year" placeholder="Enter year" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item name="dod" label="DOD">
                    <DatePicker picker="year" placeholder="Enter year" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    name="nationality"
                    label="Nationality"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Nationality is required!',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select nationality"
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                      {Country.getAllCountries().map(item => {
                        return (
                          <Option key={item.isoCode} value={item.isoCode}>
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item name="cona_code" label="Cona Code">
                    <Input placeholder="Enter cona code" style={{ textTransform: 'uppercase' }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item name="source" label="Source">
                    <Input placeholder="Enter source" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/artists')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.artists, !!artist ? artist.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Artist;
